import React from 'react';
import { Questionnaire } from '../../../models/questionnaire';
import { ChevronIcon, Chip, ChipWrapper, colourString, kebabCase } from '@keplerco/core';
import styles from './questionnaire.module.css';
import KeplerNavlink from '../../../navigation/guards/kepler-navlink';
import { PagePath } from '../../../navigation/navigation.enums';
import classNames from 'classnames';
import { useAnalysisBasePagePath } from '../use-analysis-base-page-path';

export function QuestionnaireCard(props: Questionnaire & { index: number }): JSX.Element {
  const basePagePath = useAnalysisBasePagePath();

  const isComplete = props.totalAnsweredQuestions >= props.totalQuestions;
  const hasEarned = props.keplerPointsEarned > 0;

  return isComplete ? (
    <div className={classNames('card action-card', styles.card)}>
      <div className="action-card-content">
        <ChipWrapper>
          <Chip customTheme={{ backgroundColor: 'background', borderColor: 'baby-blue', color: 'text' }}>{props.totalQuestions} skill(s)</Chip>

          {!isComplete && hasEarned && <Chip themeColour="a">In Progress</Chip>}

          {isComplete && <Chip themeColour="g">Completed</Chip>}
        </ChipWrapper>

        <h3 id={`${kebabCase(props.name)}-questionnaire`} style={{ paddingTop: 5 }}>
          {props.name ?? `Questionnaire #${props.index + 1}`}
        </h3>

        <p style={{ color: colourString('text') }}>{props.description}</p>
      </div>

      <div className={styles.progressBarContainer}>
        <progress className={styles.progressBar} value={props.totalAnsweredQuestions} max={props.totalQuestions} />
      </div>
    </div>
  ) : (
    <KeplerNavlink to={basePagePath + PagePath.analysisQuestionnaire.replace(':questionnaireSlug', props.slug)} className={classNames('card action-card interactive', styles.card)}>
      <div className="action-card-content">
        <ChipWrapper>
          <Chip customTheme={{ backgroundColor: 'background', borderColor: 'baby-blue', color: 'text' }}>{props.totalQuestions} skill(s)</Chip>

          {!isComplete && hasEarned && <Chip themeColour="a">In Progress</Chip>}

          {isComplete && <Chip themeColour="g">Completed</Chip>}
        </ChipWrapper>

        <h3 id={`${kebabCase(props.name)}-questionnaire`} style={{ paddingTop: 5 }}>
          {props.name ?? `Questionnaire #${props.index + 1}`}
        </h3>

        <p style={{ color: colourString('text') }}>{props.description}</p>
      </div>

      <ChevronIcon tone="secondary" strokeWidth={1} size={40} />

      <div className={styles.progressBarContainer}>
        <progress className={styles.progressBar} value={props.totalAnsweredQuestions} max={props.totalQuestions} />
      </div>
    </KeplerNavlink>
  );
}
